import React from 'react'
import {
  Card,
  CardActions,
  CardContent,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core'
import { LoadingContainer } from 'components/Common/LoadingContainer'
import { ReactNode } from 'react'

import './DashboardWidget.scss'
import { KPI } from 'controllers/Analytics/SalesLeadTimeController'

type Props = {
  GraphComponent: ReactNode
  onRefresh: () => void
  ConfigurationComponent?: ReactNode
  subtitle: ReactNode
  loading?: boolean
  empty?: boolean
}

export type KPITargetConfiguration = {
  kpi: KPI
  value: number
  unit: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    graphContainer: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2),
      color: theme.palette.text.primary,
      margin: theme.spacing(2),
      marginBottom: -theme.spacing(-2),
      overflow: 'visible',
      height: theme.spacing(21),
      transform: `translateY(-${theme.spacing(2)}px)`,
      borderRadius: theme.spacing(1),
      boxShadow: theme.shadows[3],
      '& .recharts-text': {
        fill: theme.palette.text.primary,
      },
    },
  })
)

export const DashboardWidget = (props: Props) => {
  const cn = useStyles()

  return (
    <Card className="dashboard-widget">
      <div className={cn.graphContainer}>
        <LoadingContainer
          loading={props.loading}
          empty={props.empty && 'data not found'}
          noMessage
        >
          {props.GraphComponent}
        </LoadingContainer>
      </div>
      <CardContent>{props.subtitle}</CardContent>
      <CardActions className="dashboard-widget-actions">
        {props.ConfigurationComponent}
      </CardActions>
    </Card>
  )
}
